import { render, staticRenderFns } from "./PageMemberConnectedSection.vue?vue&type=template&id=3df7655c&scoped=true"
import script from "./PageMemberConnectedSection.vue?vue&type=script&lang=js"
export * from "./PageMemberConnectedSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df7655c",
  null
  
)

export default component.exports